// The ORIGINAL assessment reducer derives answer order from feedback events.
// Math Rods owns a per-segment ledger (also tracking revealed/skipped segments).
// Flush that ledger only at completion, using existing public actions; no global
// reducer opt-out, no change to accepted templates' assessment behavior.
export function publishMathRodsStats(results, {dispatch, showFeedback, closeFeedback, showStats}) {
  if (!results) return;
  if (results.withScore) {
    const answers = results.data?.answersByQuestion || [];
    for (const correctFirstTry of answers) {
      if (!correctFirstTry) dispatch(showFeedback({isCorrect:false}));
      dispatch(showFeedback({isCorrect:true}));
    }
    // These accounting events are consumed synchronously by Redux. No transient
    // global modal/audio is left in state when React renders the next frame.
    dispatch(closeFeedback());
  }
  dispatch(showStats(results));
}
